<template>
  <div class="dashboard-container">
    <el-row :gutter="20">
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-title">用户总数</div>
          <div class="stat-value">{{ stats.userCount || 0 }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-title">产品总数</div>
          <div class="stat-value">{{ stats.pledgeCount || 0 }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-title">订单总数</div>
          <div class="stat-value">{{ stats.pledgeOrderCount || 0 }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-title">登录统计</div>
          <div class="stat-value">{{ stats.loginCount || 0 }}</div>
        </el-card>
      </el-col>
    </el-row>
    
    <el-row :gutter="20">
      <el-col :span="12">
        <el-card class="activity-card">
          <div slot="header">
            <span>最新活动</span>
          </div>
          <el-table 
            :data="activities" 
            style="width: 100%" 
            v-loading="loading"
            height="400"
            :header-cell-style="{background:'#f5f7fa',color:'#606266'}">
            <el-table-column prop="createTime" label="时间" width="180">
              <template slot-scope="scope">
                {{ formatDate(scope.row.createTime) }}
              </template>
            </el-table-column>
            <el-table-column prop="username" label="用户"></el-table-column>
            <el-table-column prop="remark" label="操作"></el-table-column>
          </el-table>
        </el-card>
      </el-col>
      
      <el-col :span="12">
        <el-card class="chart-card">
          <div slot="header">
            <span>用户统计数据</span>
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              align="right"
              size="mini"
              style="float: right; margin-top: -5px"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              @change="handleDateChange">
            </el-date-picker>
          </div>
          <div ref="userChart" class="chart-container"></div>
        </el-card>
      </el-col>
    </el-row>
    
    <el-row :gutter="20" style="margin-top: 20px;">
      <el-col :span="12">
        <el-card class="chart-card">
          <div slot="header">
            <span>用户地区分布</span>
          </div>
          <div ref="countryChart" class="chart-container" v-loading="countryChartLoading"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import * as echarts from 'echarts'

export default {
  name: 'Dashboard',
  data() {
    return {
      loading: false,
      chartLoading: false,
      countryChartLoading: false,
      stats: {
        userCount: 0,
        pledgeCount: 0,
        pledgeOrderCount: 0,
        loginCount: 0
      },
      activities: [],
      userStatsChart: null,
      userStats: [],
      countryChart: null,
      countryData: [],
      dateRange: null,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  methods: {
    // 获取统计数据
    fetchStats() {
      axios.get('/home')
        .then(response => {
          if (response.data.status === 200) {
            this.stats = response.data.data || {
              userCount: 0,
              pledgeCount: 0,
              pledgeOrderCount: 0,
              loginCount: 0
            }
          } else {
            this.$message.error(response.data.message || '获取统计数据失败')
          }
        })
        .catch(error => {
          const errorMsg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '网络错误，请稍后重试'
          this.$message.error(errorMsg)
          console.error('获取统计数据失败:', error)
        })
    },
    
    // 获取最新活动
    fetchActivities() {
      this.loading = true
      
      const params = {
        pageNum: 1,
        pageSize: 10
      }
      
      axios.get('/home/recording/page', { params })
        .then(response => {
          this.loading = false
          
          if (response.data.status === 200) {
            const { data } = response.data
            
            this.activities = data.data || []
          } else {
            this.$message.error(response.data.message || '获取最新活动失败')
          }
        })
        .catch(error => {
          this.loading = false
          const errorMsg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '网络错误，请稍后重试'
          this.$message.error(errorMsg)
          console.error('获取最新活动失败:', error)
        })
    },
    
    // 获取用户统计数据
    fetchUserStats() {
      this.chartLoading = true
      
      // 如果有日期范围，添加请求参数
      let params = {}
      if (this.dateRange && this.dateRange.length === 2) {
        params.startTime = this.formatDateForRequest(this.dateRange[0])
        params.endTime = this.formatDateForRequest(this.dateRange[1])
      }
      
      axios.get('/home/user/count', { params })
        .then(response => {
          this.chartLoading = false
          
          if (response.data.status === 200) {
            this.userStats = response.data.data || []
            this.renderUserStatsChart()
          } else {
            this.$message.error(response.data.message || '获取用户统计数据失败')
          }
        })
        .catch(error => {
          this.chartLoading = false
          const errorMsg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '网络错误，请稍后重试'
          this.$message.error(errorMsg)
          console.error('获取用户统计数据失败:', error)
        })
    },
    
    // 获取用户国家分布数据
    fetchCountryData() {
      this.countryChartLoading = true
      
      axios.get('/home/user/country')
        .then(response => {
          this.countryChartLoading = false
          
          if (response.data.status === 200) {
            this.countryData = response.data.data || []
            this.renderCountryChart()
          } else {
            this.$message.error(response.data.message || '获取用户国家分布数据失败')
          }
        })
        .catch(error => {
          this.countryChartLoading = false
          const errorMsg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '网络错误，请稍后重试'
          this.$message.error(errorMsg)
          console.error('获取用户国家分布数据失败:', error)
        })
    },
    
    // 渲染用户国家分布图表
    renderCountryChart() {
      // 如果图表实例已存在，销毁实例
      if (this.countryChart) {
        this.countryChart.dispose()
      }
      
      // 初始化图表
      this.countryChart = echarts.init(this.$refs.countryChart)
      
      // 准备数据
      const chartData = this.countryData.map(item => ({
        name: item.country_code,
        value: item.countNum
      }))
      
      // 图表配置
      const option = {
        title: {
          text: '用户地区分布',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: this.countryData.map(item => item.country_code)
        },
        series: [
          {
            name: '用户数量',
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '18',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: chartData
          }
        ],
        color: ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#909399', '#71c7a8', '#9d96f5', '#f7e8a4']
      }
      
      // 设置加载状态
      if (this.countryChartLoading) {
        this.countryChart.showLoading()
      } else {
        this.countryChart.hideLoading()
      }
      
      // 应用配置
      this.countryChart.setOption(option)
    },
    
    // 渲染用户统计图表
    renderUserStatsChart() {
      // 如果图表实例已存在，销毁实例
      if (this.userStatsChart) {
        this.userStatsChart.dispose()
      }
      
      // 初始化图表
      this.userStatsChart = echarts.init(this.$refs.userChart)
      
      // 准备数据
      const days = this.userStats.map(item => item.day)
      const loginData = this.userStats.map(item => item.loginCount)
      const accessData = this.userStats.map(item => item.accessCount)
      const registerData = this.userStats.map(item => item.registerCount)
      
      // 图表配置
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['登录量', '访问量', '注册量'],
          top: 10
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: days,
          axisLabel: {
            rotate: 45,
            interval: 0
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '登录量',
            type: 'bar',
            data: loginData,
            itemStyle: {
              color: '#409EFF'
            }
          },
          {
            name: '访问量',
            type: 'bar',
            data: accessData,
            itemStyle: {
              color: '#67C23A'
            }
          },
          {
            name: '注册量',
            type: 'bar',
            data: registerData,
            itemStyle: {
              color: '#E6A23C'
            }
          }
        ]
      }
      
      // 设置加载状态
      if (this.chartLoading) {
        this.userStatsChart.showLoading()
      } else {
        this.userStatsChart.hideLoading()
      }
      
      // 应用配置
      this.userStatsChart.setOption(option)
      
      // 调整窗口大小时自动调整图表大小
      window.addEventListener('resize', this.resizeChart)
    },
    
    // 处理日期变化
    handleDateChange() {
      this.fetchUserStats()
    },
    
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '未知'
      
      const date = new Date(dateStr)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
    },
    
    // 格式化日期用于请求
    formatDateForRequest(date) {
      if (!date) return ''
      const d = new Date(date)
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    },
    
    // 调整图表大小
    resizeChart() {
      if (this.userStatsChart) {
        this.userStatsChart.resize()
      }
      if (this.countryChart) {
        this.countryChart.resize()
      }
    }
  },
  created() {
    this.fetchStats()
    this.fetchActivities()
    // 设置默认日期范围为最近一周
    const endDate = new Date()
    const startDate = new Date()
    startDate.setDate(startDate.getDate() - 7)
    this.dateRange = [startDate, endDate]
    this.fetchUserStats()
    this.fetchCountryData()
  },
  mounted() {
    this.$nextTick(() => {
      this.renderUserStatsChart()
      this.renderCountryChart()
    })
  },
  beforeDestroy() {
    // 移除窗口大小变化监听器
    window.removeEventListener('resize', this.resizeChart)
    
    // 销毁图表实例
    if (this.userStatsChart) {
      this.userStatsChart.dispose()
      this.userStatsChart = null
    }
    if (this.countryChart) {
      this.countryChart.dispose()
      this.countryChart = null
    }
  }
}
</script>

<style scoped>
.dashboard-container {
  padding: 20px;
}

.stat-card {
  text-align: center;
  margin-bottom: 20px;
}

.stat-title {
  font-size: 14px;
  color: #606266;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #409EFF;
  margin-top: 10px;
}

.activity-card, .chart-card {
  margin-top: 20px;
  height: 460px;
}

.chart-container {
  height: 400px;
  width: 100%;
}
</style> 